module.exports = __webpack_public_path__ + "assets/img/img3-aaa9c81f.png";